import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatUOM as creatUOMApi,
    updateUOM as updateUOMApi,
    getAllUOM as getAllUOMApi,
    getUOM as getUOMApi,
} from './api';

// actions
import { UOMApiResponseSuccess, UOMApiResponseError } from './actions';

// constants
import { UOMActionTypes } from './constants';

type UOMData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add UOM
 * @param {*} payload
 */
function* AddUOM({ payload, type }: UOMData): SagaIterator {
    try {
        const response = yield call(creatUOMApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(UOMApiResponseSuccess(UOMActionTypes.ADD_UOM, data, message, code, false, true));
        } else {
            let msg = `An error while getting UOM!`;
            if (message) msg = message;
            yield put(UOMApiResponseSuccess(UOMActionTypes.ADD_UOM, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(UOMApiResponseError(UOMActionTypes.ADD_UOM, [], error, 404, true, false));
    }
}

/**
 * Edit UOM
 * @param {*} payload
 */
function* EditUOM({ payload, type }: UOMData): SagaIterator {
    try {
        const response = yield call(updateUOMApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                UOMApiResponseSuccess(UOMActionTypes.EDIT_UOM, data, 'UOM Get Updated Successfully', code, false, true)
            );
        } else {
            let msg = `An error while edit UOM!`;
            if (message) msg = message;
            yield put(UOMApiResponseSuccess(UOMActionTypes.EDIT_UOM, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(UOMApiResponseSuccess(UOMActionTypes.EDIT_UOM, [], error, 404, true, false));
    }
}

/**
 * Fetch UOM
 * @param {*} payload
 */
function* getUOM({ payload, type }: UOMData): SagaIterator {
    try {
        const response = yield call(getUOMApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(UOMApiResponseSuccess(UOMActionTypes.GET_UOM, data, message, code, false, false));
        } else {
            let msg = `An error while getting UOM!`;
            if (message) msg = message;
            yield put(UOMApiResponseSuccess(UOMActionTypes.GET_UOM, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(UOMApiResponseSuccess(UOMActionTypes.GET_UOM, [], error, 404, true, false));
    }
}

/**
 * Fetch UOMs
 * @param {*} payload
 */
function* getUOMs({ payload, type }: UOMData): SagaIterator {
    try {
        const response = yield call(getAllUOMApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(UOMApiResponseSuccess(UOMActionTypes.GET_UOMS, responseData, message, code, false, false));
        } else {
            let msg = `An error while getting UOM Listing!`;
            if (message) msg = message;
            yield put(UOMApiResponseSuccess(UOMActionTypes.GET_UOMS, responseData, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(UOMApiResponseSuccess(UOMActionTypes.GET_UOMS, [], error, 404, true, false));
    }
}

export function* watchgetUOM() {
    yield takeEvery(UOMActionTypes.GET_UOM, getUOM);
}

export function* watchgetUOMs() {
    yield takeEvery(UOMActionTypes.GET_UOMS, getUOMs);
}

export function* watchAddUOM() {
    yield takeEvery(UOMActionTypes.ADD_UOM, AddUOM);
}

export function* watchEditUOM(): any {
    yield takeEvery(UOMActionTypes.EDIT_UOM, EditUOM);
}

function* UOMSaga() {
    yield all([fork(watchgetUOM), fork(watchAddUOM), fork(watchEditUOM), fork(watchgetUOMs)]);
}

export default UOMSaga;
